import { getUserFields } from "components/user/config";
import {
  deleteItemFromCollection,
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";
import { invalidateAllQueries } from "utils/utils";

export async function deleteDraftTimesheetEntry({ id }) {
  try {
    const query = { fields: ["id"] };
    const data = await deleteItemFromCollection("draft_timesheet", id, query);
    invalidateAllQueries();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchDraftTimesheetEntry({ draftId }) {
  try {
    const query = {
      fields: [
        "id",
        "date",
        "logged_hours",
        "description",
        "department",
        getUserFields("employee"),
        "tag.id",
        "tag.label",
        "tag.color",
        "date_created",
        "date_updated",
      ],
    };
    const res = await getItemFromCollection("draft_timesheet", draftId, query);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchTags() {
  try {
    const query = {
      fields: ["id", "label", "color"],
      filter: {
        for: {
          _eq: "timesheet",
        },
      },
      sort: ["label"],
    };
    const res = await getItemsFromCollection("tags", query);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

